import { render, staticRenderFns } from "./CollectionVector.vue?vue&type=template&id=a721cb98&"
import script from "./CollectionVector.vue?vue&type=script&lang=js&"
export * from "./CollectionVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports